import { BsCurrencyDollar, BsJournalText, BsLightbulb } from "react-icons/bs";
import { FaBriefcase, FaChalkboardTeacher, FaChartLine, FaGamepad, FaRoute, FaTrophy } from "react-icons/fa";
import { IoIosHome, IoMdHelpBuoy } from "react-icons/io";

import { ImBooks } from "react-icons/im";
import { MdLaptop, MdOutlineAdminPanelSettings, MdShoppingCart } from "react-icons/md";
import { IoIosBookmarks } from "react-icons/io";
import { GiProcessor } from "react-icons/gi";

import React from "react";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import { Badge } from "primereact/badge";

const SidebarItems = [
	{
		title: "Home",
		descripcion: "Home description" ,
		id: "",
		path: multiViewComponentsPaths.home,
		icon: <IoIosHome />,
		classNames: "home-icon",
		permittedTo: [...typesTiposUsuario.todosUsuarios],
	},
	{
		title: "Home",
		descripcion: "Home description" ,
		id: "",
		path: multiViewComponentsPaths.home,
		icon: <IoIosHome />,
		classNames: "home-icon",
		permittedTo: typesTiposUsuario.gestion ,
	},
	{
		title: "Home",
		descripcion: "Home description" ,
		id: "",
		path: multiViewComponentsPaths.homeInvitado,
		icon: <IoIosHome />,
		classNames: "home-icon",
		permittedTo: [typesTiposUsuario.invitado, typesTiposUsuario.cortesia],
	},
	{
		title: "Home",
		descripcion: "Home description" ,
		id: "",
		path: multiViewComponentsPaths.homeLecturaVeloz,
		icon: <IoIosHome />,
		classNames: "home-icon",
		permittedTo: [typesTiposUsuario.lecturaVeloz, typesTiposUsuario.asesorLectura],
	},
	{
		title: "Click+ Misions",
		descripcion: "Click+ Misions description" ,
		id: "",
		path: multiViewComponentsPaths.misiones,
		icon: <FaTrophy />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		title: "Entertainment title",
		descripcion: "Entertainment room" ,
		id: "",
		path: multiViewComponentsPaths.salaEntretenimiento,
		icon: <FaGamepad />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		title: "Entertainment title",
		descripcion: "Entertainment room" ,
		id: "",
		path: multiViewComponentsPaths.salaEntretenimiento,
		icon: <FaGamepad />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.gestion,
	},
	{
		title: "Learning title",
		descripcion: "Learning routes" ,
		id: "",
		path: multiViewComponentsPaths.rutasAprendizaje,
		icon: <FaRoute />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		title: "Quick tips",
		descripcion: "Quick tips description" ,
		id: "",
		path: multiViewComponentsPaths.consejosRapidos,
		icon: <BsLightbulb />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		// title: 'Foro de Ayuda: Notificaciones nuevas',
		title: (notificacionDisponible) => (notificacionDisponible ? "Help forum notifications" : "Help forum"),
		descripcion: "Help forum description" ,
		id: "",
		path: multiViewComponentsPaths.foroAyuda,
		// icon: <TiMessages />,
		icon: (notificacionDisponible) => (
			<i className="pi pi-comments p-overlay-badge" style={{ fontSize: "1rem" }}>
				{notificacionDisponible && <Badge className="notificacion-foroayuda" severity="danger"></Badge>}
			</i>
		),
		className: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},

	{
		// title: 'Foro de Ayuda: Notificaciones nuevas',
		title: (notificacionDisponible) => (notificacionDisponible ? "Help forum notifications" : "Help forum"),
		descripcion: "Help forum description" ,
		id: "",
		path: multiViewComponentsPaths.foroAyuda,
		// icon: <TiMessages />,
		icon: (notificacionDisponible) => (
			<i className="pi pi-comments p-overlay-badge" style={{ fontSize: "1rem" }}>
				{notificacionDisponible && <Badge className="notificacion-foroayuda" severity="danger"></Badge>}
			</i>
		),
		className: "nav-text",
		permittedTo: typesTiposUsuario.gestion,
	},
	{
		title: "My courses",
		descripcion: "My courses description",
		path: multiViewComponentsPaths.misCursos,
		icon: <ImBooks />,
		classNames: "nav-text",
		permittedTo: [...typesTiposUsuario.todosUsuarios, typesTiposUsuario.invitado, typesTiposUsuario.lecturaVeloz, typesTiposUsuario.cortesia, typesTiposUsuario.gestion],
	},
	{
		title: "Consulting title",
		descripcion: "Consulting agenda" ,
		id: "sidebar-item-agendas",
		path: multiViewComponentsPaths.agendasAsesorias,
		icon: <IoIosBookmarks />,
		classNames: "nav-text",
		permittedTo: [...typesTiposUsuario.todosUsuarios],
	},

	// {
	// 	title: "Plantillas de Trabajo",
	// 	descripcion: "" ,
	// 	id: "working-templates",
	// 	path: multiViewComponentsPaths.plantillasTrabajo,
	// 	icon: <BsJournalText />,
	// 	className: "nav-text",
	// 	permittedTo: typesTiposUsuario.todosUsuarios,
	// },
	// {
	// 	title: "Asesor Virtual",
	// 	id: "chat-ia",
	// 	icon: <BiUserPin />,
	// 	path: multiViewComponentsPaths.openAI,
	// 	permittedTo: typesTiposUsuario.todosUsuarios,
	// },
	{
		title: "AI Suite",
		descripcion: "AI Suite description" ,
		id: "suite-ia",
		icon: <GiProcessor />,
		path: multiViewComponentsPaths.suiteAI,
		permittedTo: typesTiposUsuario.todosUsuarios,
	},

	{
		title: "AI Suite",
		descripcion: "AI Suite description" ,
		id: "suite-ia",
		icon: <GiProcessor />,
		path: multiViewComponentsPaths.suiteAI,
		permittedTo: typesTiposUsuario.gestion,
	},
	{
		title: "Bussiness forum",
		descripcion: "Bussiness forum description",
		id: "",
		path: multiViewComponentsPaths.foroEmpresarial,
		icon: <FaBriefcase />,
		className: "nav-text",
		permittedTo: typesTiposUsuario.usuariosEmpresariales,
	},

	{
		title: "Foro de lectura",
		descripcion: "Gestiona tus licencias contratadas.",
		id: "",
		path: multiViewComponentsPaths.foroLectura,
		icon: <FaBriefcase />,
		className: "nav-text",
		permittedTo: [typesTiposUsuario.asesorLectura],
	},
	// {
	// 	title: "Aula Virtual",
	// 	descripcion: "" ,
	// 	id: "",
	// 	path: multiViewComponentsPaths.aulaVirtual,
	// 	icon: <FaChalkboardTeacher />,
	// 	classNames: "nav-text",
	// 	permittedTo: typesTiposUsuario.todosUsuarios,
	// },
	{
		title: "Advances",
		descripcion: "My Advances" ,
		id: "",
		path: multiViewComponentsPaths.misAvances,
		icon: <FaChartLine />,
		className: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		title: "Advances",
		descripcion: "My Advances" ,
		id: "",
		path: multiViewComponentsPaths.misAvances,
		icon: <FaChartLine />,
		className: "nav-text",
		permittedTo: typesTiposUsuario.gestion,
	},
	{
		title: "Help center",
		descripcion: "Help center decription" ,
		id: "",
		path: multiViewComponentsPaths.centroAyuda,
		icon: <IoMdHelpBuoy />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios,
	},
	{
		title: "Help center",
		descripcion: "Help center decription" ,
		id: "",
		path: multiViewComponentsPaths.centroAyuda,
		icon: <IoMdHelpBuoy />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.gestion,
	},
	{
		title: "My payments",
		descripcion: "My payments description" ,
		id: '',
		path: multiViewComponentsPaths.misPagos,
		icon: <BsCurrencyDollar />,
		classNames: 'nav-text',
		permittedTo: [ typesTiposUsuario.administrador, typesTiposUsuario.asesor, typesTiposUsuario.estudiante ]
	},
	{
		title: "MOS preparatory course",
		descripcion: "MOS preparatory course description" ,
		id: "",
		path: multiViewComponentsPaths.cursoPropedeuticoMos,
		icon: <MdLaptop />,
		classNames: "nav-text",
		permittedTo: typesTiposUsuario.todosUsuarios.filter((usuario) => usuario !== typesTiposUsuario.vendedor),
	},
	// {
	// 	title: "Panel de Administración",
	// 	descripcion: "Gestiona el contenido de la plataforma" ,
	// 	id: "",
	// 	path: multiViewComponentsPaths.panelAdministracion,
	// 	icon: <MdOutlineAdminPanelSettings />,
	// 	classNames: "nav-text",
	// 	permittedTo: [typesTiposUsuario.administrador, typesTiposUsuario.capacitador, typesTiposUsuario.vendedor],
	// },
	// {
	// 	title: "Adquirir Licencia Premium",
	// 	descripcion: "Adquiere tu licencia Premium Click+ y disfruta de todas las herramientas y cursos que la plataforma tiene para ti" ,
	// 	id: "",
	// 	path: multiViewComponentsPaths.solicitudLlamadaVenta,
	// 	icon: <MdShoppingCart />,
	// 	classNames: "nav-text",
	// 	permittedTo: [typesTiposUsuario.invitado, typesTiposUsuario.lecturaVeloz, typesTiposUsuario.cortesia],
	// },
];

export default SidebarItems;
